import staff from './staff'
import workMode from './work-mode'
import overtimeData from './overtime-data'

export default [
  ...staff,
  ...workMode,
  ...overtimeData,
]
